import styled from '@xstyled/styled-components'
import { mediaBreakpointUp } from '../../theme/core/breakpoints'
import { numericAvatarSizeToCircleSize } from '../AvatarV2'

export const StyledPlayerHeaderContent = styled.div({
  position: 'relative',
  height: '100%',
  width: '100%',
  maxWidth: 1400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '0 16px',
  margin: '0 auto',
  [mediaBreakpointUp('md')]: {
    padding: '0 24px'
  }
})

const borderRadius = 3

export const StyledPlayerHeaderAvatarRoot = styled.div({
  position: 'absolute',
  margin: '0 auto',
  left: 0,
  right: 0,
  top: -((numericAvatarSizeToCircleSize('lg') + borderRadius * 2) / 2),
  padding: '0 16px',
  [mediaBreakpointUp('md')]: {
    top: -((numericAvatarSizeToCircleSize('xl') + borderRadius * 2) / 2),
    padding: '0 24px'
  },
  [mediaBreakpointUp('lg')]: {
    padding: '0 40px'
  }
})

export const StyledPlayerHeaderAvatarWrapper = styled.div({
  width: '100%',
  maxWidth: 748,
  margin: '0 auto'
})

const CommonStyledAvatarWrapper = styled.div(
  {
    marginLeft: 12,
    borderRadius: '50%',
    background: 'white',
    border: '3px solid white',
    boxSizing: 'border-box'
  },
  props => ({
    boxShadow: props.theme.shadows.lg
  })
)

export const LGStyledAvatarWrapper = styled(CommonStyledAvatarWrapper)({
  display: 'inline-flex',
  '& > div': {
    width: numericAvatarSizeToCircleSize('lg') - 6,
    height: numericAvatarSizeToCircleSize('lg') - 6
  },
  [mediaBreakpointUp('md')]: {
    display: 'none'
  }
})

export const XLStyledAvatarWrapper = styled(CommonStyledAvatarWrapper)({
  display: 'none',
  '& > *': {
    width: numericAvatarSizeToCircleSize('xl') - 6,
    height: numericAvatarSizeToCircleSize('xl') - 6
  },
  [mediaBreakpointUp('md')]: {
    display: 'inline-flex'
  }
})

export const StyledButtonGroup = styled.div({
  display: 'flex',
  '>:not(:last-child)': {
    marginRight: 8
  }
})
